import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {QARService, SystemEntity, SystemLoaderEntity, SystemRoleEntity} from '../services/qar.service';
import {AppUser} from '../framework/AppUser';
import {UIDirectiveDownload} from '../framework/ui/download';
import {UITableComponentHeader, UITableComponentOptions} from '../framework/ui/table';
import {FileInfo} from '../framework/ui/uploader';


@Component({
	selector: 'app-page-sar',
	templateUrl: './systems.html',
	providers: [QARService]
})
export class SystemsPageComponent implements OnInit {
	public self = this;

	@ViewChild(UIDirectiveDownload, {static: false}) downloader;

	constructor(public api: QARService, public user: AppUser) {
	}

	//#region uploaad
	uploadAcceptsFile(file: File): boolean | string {
		console.log({uploadAcceptsFile: file});
		if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			return 'this must be an Excel file';
		}
		return true;
	}

	uploadDone(files: FileInfo[]) {
		console.log('uploadDone', {files});
		let lastUploaded: FileInfo = null;
		for (const f of files) {
			lastUploaded = f;
		}
		this.api.systemLoaderUpload(this.systems.selectedId, lastUploaded).then((r) => {
			alert('File uploaded successfully, please run dry run to make sure the file is working');
		});
	}

	//#endregion

	public modalAlert = {
		type: '',
		display: false,
		text: '',
		title: '',
		cb: (yesorno) => {
		}
	};

	public alert(text, title = 'Alert', type = 'alert') {
		this.modalAlert.display = type !== 'success';
		this.modalAlert.title = title;
		this.modalAlert.text = text;
		this.modalAlert.type = type;
		this.modalAlert.cb = (yesorno) => {
			this.modalAlert.display = false;
		};
	}

	public isAuditor = false;
	public isAdmin = false;

	ngOnInit() {
		this.isAuditor = this.user.hasGroup('AUDITORS');
		this.isAdmin = this.user.hasGroup('ADMINS');
		this.systems_loadAll();
	}

	public systems = {
		loading: false,
		selected: null,
		selectedId: null,
		chunker: (new Chunker([])),
		chunkedData: [],
		all: []
	};

	public static countSystemLoaderEnabled(sys: SystemEntity): number {
		let ret = 0;
		for (const l of sys.Loaders) {
			if (!l.IsDeleted) {
				ret++;
			}
		}
		return ret;
	}

	public helper_countSystemLoaderEnabled(system): number {
		return SystemsPageComponent.countSystemLoaderEnabled(system);
	}

	systems_loadAll(): Promise<void> {
		return new Promise<void>((ok, err) => {
			this.systems.loading = true;
			this.api.retrieveSystems().then(r => {
				this.systems.loading = false;
				this.systems.chunker = new Chunker(r);
				this.systems.all = r;
				ok(null);
			});
		});
	}

	public systems_onRowClick(report) {
		return new Promise<void>((ok, err) => {
			this.systems.selected = report;
			this.systems.selectedId = report.Id;
			this.system.configuration.data = '';
			this.system.data = report;
			Object.assign(this.system.originalData, report);
			this.system.sodApprovers.data = report.SodApprover ? report.SodApprover.split(',') : [];

			this.system.loadingRoles = true;
			this.system_loadRoles();
			ok(null);
		});
	}

	public system_loadRoles() {
		this.api.retrieveSystemsRolesForSystemId(this.systems.selectedId).then(r => {
			this.system.rolesPaired = {};
			this.system.roles = [];
			for (const role of r) {
				if (role.Pairing) {
					if (!this.system.rolesPaired[role.PairingId]) {
						this.system.rolesPaired[role.PairingId] = {
							pairing: role.Pairing,
							roles: []
						};
					}
					this.system.rolesPaired[role.PairingId].roles.push(role);
				} else {
					this.system.roles.push(role);
				}
			}
			this.system.loadingRoles = false;
		});
	}

	public system = {
		configuration: {
			data: {},
			loaderData: {},
			modalHidden: true
		},
		loading: false,
		loadingRoles: false,
		roles: [],
		rolesPaired: {},
		saving: false,
		originalData: new SystemEntity(),
		data: new SystemEntity(),
		updatingLoader: {},
		pairedRoles: {},
		pairing: false,
		unpairing: {},
		dryrun: {
			loading: {},
			raw: null as string,
			modalHidden: true,
			loadingAll: true,
			title: '',
			noRoles: true,
			dataRoles: [],
			chunker: new Chunker([]),
			chunkedData: [],
			tableOptions: {
				downloadAsExcel: true,
				downloadAsExcelHeaders: () => {
					return [{label: 'User Name', id: 'UserName'}, {label: 'Role Name', id: 'RoleName'}];
				},
				downloadAsExcelRowFormatter: (headerId, currentValue, r) => {
					console.log('downloadAsExcelRowFormatter', {headerId, currentValue, r});
					return r[headerId];
				}
			} as UITableComponentOptions,
			tableHeaders: [
				{id: 'UserName', label: 'User Name', filterable: true, sortable: 'string'},
				{id: 'RoleName', label: 'Role Name', filterable: true, sortable: 'string'}
			] as UITableComponentHeader[]
		},
		newLoader: {
			modalHidden: true,
			saving: false,
			ad: {
				groups: [],
				accessGroups: []
			},
			type: '',
			entity: {} as SystemLoaderEntity
		},
		newRole: {
			name: '',
			systemId: null,
			saving: false,
			modalHidden: true
		},
		newSystem: {
			entity: {} as SystemEntity,
			saving: false,
			modalHidden: true
		},
		sodApprovers: {
			newEmail: '',
			data: [],
			validating: false,
			error: false,
			errorDuplicate: false,
			saving: false,
			dataSelected: []
		},
		tableHeaders: [
			{id: 'Id', label: 'Id', filterable: true},
			{id: 'Name', label: 'System Name', filterable: true, style: 'width:300px'},
			{id: 'Description', label: 'Description', filterable: true, style: 'width:200px'},
			{id: '', label: 'Loader Enabled', filterable: true, idFunction: SystemsPageComponent.helper_loaderCount, style: 'width:100px'},
			{id: 'SodApprover', label: 'SOD Approver', filterable: true},
			{
				id: 'reports',
				label: 'Special',
				filterable: true,
				idFunction: SystemsPageComponent.helper_reportsIncluded,
				type: 'dropdown',
				options: {noEmptyChoice: false, choices: {qs: 'QAR+SOD'}, emptyChoiceText: '(Any)'}
			},
		]
	};

	static helper_loaderCount(row) {
		return SystemsPageComponent.countSystemLoaderEnabled(row);
	}

	static helper_reportsIncluded(row) {
		return (row.IncludeInQARReport ? 'q' : 'x') + (row.IncludeInQARReport ? 's' : 'x');
	}

	public helper_inArray(needle: string, arr: string[]): boolean {
		return needle && arr.indexOf(needle) !== -1;
	}

	kindaValidEmail(w) {
		// console.log('kindaValidEmail', w, w.length, w.indexOf('@'));
		return w.length >= 12 && w.indexOf('@') !== -1;
	}

	sodApprovers_save() {
		return new Promise((ok, err) => {
			this.system.sodApprovers.saving = true;
			this.system.data.SodApprover = this.system.sodApprovers.data.join(',');
			this.api.updateSystem(this.system.data).then(r => {
				Object.assign(this.system.originalData, this.system.data);
				this.system.saving = false;
				this.alert('Record has been saved successfully.', '');
			});
		});
	}


	length(w) {
		return w.length;
	}

	public system_hasRolePaired() {
		return Object.keys(this.system.rolesPaired).length > 0;
	}

	public system_toggleLoader(loaderEntity: SystemLoaderEntity) {
		this.system.updatingLoader[loaderEntity.Id] = true;
		this.api.updateLoader(this.system.data.Id, loaderEntity.Id, !loaderEntity.IsDeleted).then(r => {
			loaderEntity.IsDeleted = !loaderEntity.IsDeleted;
			this.system.updatingLoader[loaderEntity.Id] = false;
		}, e => {
			alert('Sorry, something went wrong, please try again');
			this.system.updatingLoader[loaderEntity.Id] = false;
		});
	}

	public system_openModalAddRole() {
		this.system.newRole.modalHidden = false;
	}

	public system_loadConfiguration() {
		this.api.retrieveSystemConfiguration(this.systems.selectedId).then(r => {
			this.system.configuration.data = r;
		}, e => {
			if (e.status === 404) {
				alert('No configuration found for this system (it might be configured loader by loader)');
			} else {
				throw e;
			}
		});
	}

	public system_addRole() {
		if (!this.system.newRole.name) {
			this.alert('Please enter a name', 'Alert');
		} else {
			this.system.newRole.saving = true;
			this.api.addRoleToSystem(this.systems.selectedId, this.system.newRole.name).then(r => {
				this.system.newRole.saving = false;
				this.system.newRole.modalHidden = true;
				this.system_loadRoles();
				this.system.newRole.name = '';
				this.alert('', 'Role added to ' + this.system.data.Name, 'success');
			});
		}
	}

	public system_dryRunSOD() {
		this.downloader.download(this.api.systemSODReportDryRunURL(this.systems.selectedId));
	}

	public system_dryRunLoader(loader) {
		console.log('loader dry run', loader);
		this.system.dryrun.raw = null;
		this.system.dryrun.modalHidden = false;
		this.system.dryrun.loading[loader.Id] = true;
		this.system.dryrun.loadingAll = true;
		this.system.dryrun.dataRoles = [];
		this.system.dryrun.noRoles = true;
		this.system.dryrun.title = this.system.data.Name + ' ' + loader.Name;
		this.api.systemLoaderDryRun(this.systems.selectedId, loader.Id).then(r => {
			this.system.dryrun.loadingAll = false;
			this.system.dryrun.loading[loader.Id] = false;
			this.system.dryrun.chunker = new Chunker(r);
			this.api.systemLoaderDryRunForRoles(this.systems.selectedId, loader.Id).then(r2 => {
				this.system.dryrun.dataRoles = r2;
				this.system.dryrun.noRoles = r2 === null;
			});
		}, e => {
			this.system.dryrun.modalHidden = true;
			alert('Sorry, something went wrong');
			this.system.dryrun.loadingAll = false;
			this.system.dryrun.loading[loader.Id] = false;
		});
	}

	public system_loadConfigurationForLoader(loader: SystemLoaderEntity) {
		this.system.configuration.loaderData = JSON.stringify(JSON.parse(loader.JSON), null, 4);
		this.system.configuration.modalHidden = false;
	}

	public system_dryRunRaw(loader) {
		console.log('loader dry run raw', loader);
		this.system.dryrun.modalHidden = false;
		this.system.dryrun.loading[loader.Id] = true;
		this.system.dryrun.loadingAll = true;
		this.system.dryrun.dataRoles = [];
		this.system.dryrun.noRoles = true;
		this.system.dryrun.title = this.system.data.Name + ' ' + loader.Name + ' (raw data)';

		this.api.systemLoaderDryRunRaw(this.systems.selectedId, loader.Id).then(r => {
			this.system.dryrun.loadingAll = false;
			this.system.dryrun.loading[loader.Id] = false;
			// beautify
			this.system.dryrun.raw = JSON.stringify(r, null, 4);
		}, e => {
			this.system.dryrun.modalHidden = true;
			alert('Sorry, something went wrong, ' + (e.error ? e.error : e.message));
			this.system.dryrun.loadingAll = false;
			this.system.dryrun.loading[loader.Id] = false;
		});
	}

	public system_pairedRolesCount() {
		let count = 0;
		for (const gr in this.system.pairedRoles) {
			if (this.system.pairedRoles[gr]) {
				count++;
			}
		}
		return count;

	}


	public system_unpairRoles(pairingId: number) {
		this.system.unpairing[pairingId] = true;
		this.api.unpairRoles(pairingId).then(() => {
			this.system_loadRoles();
		}).catch(e => {
			console.error(e);
			alert('Please try again');
		}).finally(() => {

			this.system.unpairing[pairingId] = false;
		});
	}

	public system_pairRoles() {
		if (this.system_pairedRolesCount() < 2) {
			return alert('please select at least 2 roles');
		}
		const roleIds = [];
		for (const roleId in this.system.pairedRoles) {
			if (this.system.pairedRoles[roleId]) {
				roleIds.push(roleId);
			}
		}
		this.system.pairing = true;
		const name = prompt('Please enter the name of this pairing');
		if (name) {
			this.api.pairRoles(name, this.systems.selectedId, roleIds).then(() => {
				this.system_loadRoles();
				this.system.pairedRoles = {};
			}).catch(e => {
				console.error(e);
				alert('Please try again');
			}).finally(() => {

				this.system.pairing = false;
			});
		} else {

			this.system.pairing = false;
		}
	}


	public comments_save() {
		this.system.saving = true;
		this.api.updateSystem(this.system.data).then(r => {
			Object.assign(this.system.originalData, this.system.data);
			this.system.saving = false;
			this.alert('Record has been saved successfully.', '');
		});
	}

	public system_reload(): Promise<void> {
		return new Promise((ok, err) => {
			this.systems_loadAll().then(() => {
				// find back the system
				for (const s of this.systems.all) {
					if (s.Id === this.systems.selectedId) {
						this.systems_onRowClick(s).then(() => {
							ok(null);
						});
						break;
					}
				}

			});
		});
	}

	public system_deleteLoader(loader: SystemLoaderEntity) {
		if (confirm('Are you sure you want to delete this loader "' + loader.Name + '"?')) {
			this.api.systemDeleteLoader(this.systems.selectedId, loader.Id).then(() => {
				this.system_reload();
			});
		}
	}

	public system_saveConfiguration() {
		this.api.updateSystem(this.system.data).then(() => {
			this.system_reload();
		});
	}

	public system_newLoader_showModal() {
		this.system.newSystem.modalHidden = false;
		this.system.newLoader.ad.groups = [];
		this.system.newLoader.ad.accessGroups = [];
		this.system.newLoader.type = '';
	}

	public system_addLoader() {
		this.system.newLoader.saving = true;

		// transform the data
		this.system.newLoader.entity.Type = this.system.newLoader.type;


		this.api.systemAddLoader(this.system.data.Id, this.system.newLoader.entity).then(r => {
			this.system_reload().then(() => {
				this.system.newLoader.saving = false;
			});
		}, e => {
			alert('Error,' + e.error);
			this.system.newLoader.saving = false;
		});
	}

	public system_newLoader_applyConfiguration() {
		if (this.system.newLoader.type === 'AD') {
			this.system.newLoader.entity.JSON = JSON.stringify({
				Groups: this.system.newLoader.ad.groups,
				AccessGroups: this.system.newLoader.ad.accessGroups
			}, null, 4);
		}
	}

	public system_add() {
		this.system.newSystem.saving = true;
		this.api.systemAdd(this.system.newSystem.entity).then(r => {
			this.system.newSystem.modalHidden = true;
			this.system_reload().then(() => {
				this.system.newSystem.saving = false;
			});
		}, e => {
			alert('Error,' + e.error);
			this.system.newSystem.saving = false;
		});
	}
}
